import { Pipe, PipeTransform } from '@angular/core';
import { toPercentString } from '../utils/to-percent-string';

@Pipe({ name: 'pctNumDE' })
export class PctNumDEPipe implements PipeTransform {
  transform(value?: number | string | null): string {
    return toPercentString(value);
  }
}
